<span class="u-color-white" [innerHTML]="data.html"></span>
<div class="mat-simple-snackbar-action ng-star-inserted text-right" (click)="snackBar.dismiss()">
  <button mat-stocked-button class="mat-focus-indicator mat-button mat-button-base">{{ "OK" }}</button>
</div>
